import { createSlice } from "@reduxjs/toolkit";

export const dimensionesSlices = createSlice({
  name: "dimensiones",
  initialState: {
    value: [],
  },
  reducers: {
    addList: (state, action) => {
      //
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addList } = dimensionesSlices.actions;

export default dimensionesSlices.reducer;
